export default [
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Currency',
    },
    cell: {
      type: 'text',
      value: (e) => e.currencyTitle,
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Turnover volume',
      sort: 'volume',
    },
    cell: {
      type: 'slot',
      name: 'volume',
    },
  },
  {
    width: 15,
    header: {
      type: 'text',
      caption: 'Fee',
      sort: 'fee',
    },
    cell: {
      type: 'slot',
      name: 'fee',
    },
  },
];
